import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {StockReplenishmentResponse} from '../models/replenishment-stock-response.model';
import {ReplenishmentRequest} from '../models/replenishment-request.model';
import {StockReplenishRequest, StockReplenishResponse,} from '../models/stock-replenish-request.model';
import {ReplenishCapacityResponse, ReplenishmentCapacityRequest,} from '../models/showroom-capacity.model';
import {environment} from '../../environments/environment';
import {
    RequestReplenishmentRequest,
    RequestReplenishmentResponse,
    RequestVehicleRequest,
} from '../models/request-vehicle.model';
import {RequestReplenishmentMessageResponse} from '../models/request-replenishment.model';
import {AuthService} from "./auth.service";

@Injectable({
  providedIn: 'root',
})
export class ReplenishmentService {
  constructor(private http: HttpClient,
              private authService: AuthService) {}

    private getHeaders(): HttpHeaders {
        const token = this.authService.getAccessToken() || '';
        const host = window.location.hostname.toLowerCase();
        const domainExt = host.match(/\.(com|net)/)?.[0] || '';
        const domainStr = domainExt === '.com' ? 'com' : 'net';

        let headers = new HttpHeaders()
            .set('Authorization', `${token}`)
            .set('domain', domainStr);

        return headers;
    }
  getReplenishmentVehicle(
    requestPayload: ReplenishmentRequest
  ): Observable<StockReplenishmentResponse> {
    const url = '/replenishment/vehicles';
      return this.http.post<StockReplenishmentResponse>(url, requestPayload, {headers: this.getHeaders()});
  }

  getStockReplenishment(
    requestPayload: StockReplenishRequest
  ): Observable<StockReplenishResponse> {
    const url = '/replenishment/stock';
      return this.http.post<StockReplenishResponse>(url, requestPayload, {headers: this.getHeaders()});
  }

  getStockReplenishmentCapacity(
    requestPayload: ReplenishmentCapacityRequest
  ): Observable<ReplenishCapacityResponse> {
    const url = '/replenishment/capacity';
      return this.http.post<ReplenishCapacityResponse>(url, requestPayload, {headers: this.getHeaders()});
  }
  cancelReplenishment(
    requestPayload: RequestVehicleRequest
  ): Observable<RequestReplenishmentResponse> {
    const url = '/replenishment/cancel';
      return this.http.post<RequestReplenishmentResponse>(url, requestPayload, {headers: this.getHeaders()});
  }
  requestDemoVehicle(
    requestPayload: RequestVehicleRequest
  ): Observable<object> {
    const url = '/replenishment/demo-request';
      return this.http.post<object>(url, requestPayload, {headers: this.getHeaders()});
  }
  requestReplenishmentVehicle(
    requestPayload: RequestReplenishmentRequest
  ): Observable<RequestReplenishmentMessageResponse> {
    const url = '/replenishment/request';
    return this.http.post<RequestReplenishmentMessageResponse>(
      url,
        requestPayload,
        {headers: this.getHeaders()}
    );
  }
}
